export default function UserKnowledgeLoader() {
  return (
    <div className="min-h-screen bg-base-200 relative">
      <div className="container mx-auto px-4 py-10 max-w-3xl">
        <div className="bg-base-100 rounded-xl shadow-sm p-6 border border-base-300">
          <h2 className="text-xl font-bold mb-4">Loading Page...!</h2>
          <div className="flex flex-col gap-2">
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="w-full h-14 bg-base-100 animate-pulse rounded-md border border-base-300 shadow-sm"></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}